import { api } from './BaseService'

export const getCategories = async () => {
    return await api.get(`/product_categories`)
}

export const getCategoryById = async (id) => {
    return await api.get(`/product_categories/${id}`)
}

export const createCategory = async (data) => {
    return await api.post(`/product_categories`, data)
}
export const updateCategory = async (data) => {
    return await api.put(`/product_categories/${data?.get('id')}`, data)
}
export const deleteCategory = async (id) => {
    return await api.delete(`/product_categories/${id}`)
}
